import { ChangeEvent, FC, useCallback } from 'react';
import { useField } from 'react-final-form';

import {
  Checkbox,
  CheckboxProps,
} from '@beeline/design-system-react/extracted-styles';

export interface FormCheckboxProps extends Omit<CheckboxProps, 'checked'> {
  name: string;
}

export const FormCheckbox: FC<FormCheckboxProps> = ({
  name,
  onChange,
  ...rest
}) => {
  const { input } = useField(name, { type: 'string' });

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      input.onChange(e.target.checked);
      onChange?.(e);
    },
    [input, onChange],
  );

  return <Checkbox {...rest} checked={input.value} onChange={handleChange} />;
};
